module.exports = __webpack_public_path__ + "img/1557614093212393474.2d5ed5d8.png";